if (!customElements.get('pastael-help-center')) {
  customElements.define(
    'pastael-help-center',
    class PastaelHelpCenter extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-help-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-help-panel]'));

        if (this.tabs.length === 0 || this.panels.length === 0) return;

        this.onTabClick = this.onTabClick.bind(this);
        this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));

        const initialTab = this.tabs.find((tab) => tab.classList.contains('is-active')) || this.tabs[0];
        this.activateTab(initialTab);
      }

      disconnectedCallback() {
        this.tabs?.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
      }

      onTabClick(event) {
        this.activateTab(event.currentTarget);
      }

      activateTab(tab) {
        const category = tab.dataset.helpTab;
        if (!category) return;

        this.tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          item.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.helpPanel === category;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }
    }
  );
}
